<template>
  <div v-if="taskDefinition">
    <!-- Vue mount component but props is undefined -->
    <RawJsonToggler :json="taskDefinition" />
    <div>
      <!-- Workflow Definition -->
      <h1>{{ taskDefinition.name }}</h1>
      <!-- Actions -->
      <Fieldset legend="Actions">
        <router-link
          v-if="!readOnly"
          tag="button"
          :to="{ name: 'taskDefinitionEdit', params: { taskType: taskType } }"
        >
          Edit
        </router-link>
      </Fieldset>
      <DataList :data="taskDefinition" :attributes="attributes" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataList from '@/components/DataList.vue'
import Fieldset from '@/components/Fieldset.vue'
import RawJsonToggler from '@/components/RawJsonToggler.vue'

export default {
  name: 'TaskDefinition',
  props: ['taskType'],
  data() {
    return {
      attributes: [
        { name: 'ownerApp', type: 'text' },
        { name: 'description', type: 'text' },
        { name: 'createTime', type: 'date' },
        { name: 'updateTime', type: 'date' }
      ]
    }
  },
  computed: mapState(['taskDefinition', 'readOnly']),
  methods: mapActions(['getTaskDefinition']),
  created() {
    this.getTaskDefinition(this.taskType)
  },
  watch: {
    taskType: function() {
      this.getTaskDefinition(this.taskType)
    }
  },
  components: {
    DataList,
    Fieldset,
    RawJsonToggler
  }
}
</script>
